import { usePreferences } from '../context/PreferencesContext';

declare const analytics: { track: (event: string, data: Record<string, unknown>) => void };

const useTrackEvent = () => {
  const { preferences } = usePreferences();

  return (eventName: string, data: Record<string, unknown>) => {
    const url = window.location.href;
    const subdomain = url.split('.')[0].split('//')[1].split('/')[0];

    if (!preferences['analytical'] || preferences['analytical'] === false) {
      return;
    }

    try {
      const organization =
        import.meta.env.VITE_ORGANIZATION_NAME || subdomain || 'Thuisleefgroep';

      const validData =
        data && typeof data === 'object' && !Array.isArray(data) ? data : {};

      const segmentData = {
        organization,
        platform: 'Thuisleefwijzer',
        ...validData,
      };

      if (typeof analytics !== 'undefined') {
        analytics.track(eventName, segmentData);
      } else {
        console.warn('Analytics object is not defined');
      }
    } catch (error) {
      console.error('Error in trackEvent:', error);
    }
  };
};

export default useTrackEvent;
